import {IRouteConstructorOptions, Route} from './route';
import {computed, makeObservable, observable} from 'mobx';

export interface IRouteOptions {
    permissionCodes?: string[];
}

export interface IRoutes {
    [routeCode: string]: Omit<IRouteConstructorOptions, 'code'> & IRouteOptions;
}

export class RouteStore {

    @observable
    private readonly _routes: Map<string, Route> = new Map();

    constructor() {
        makeObservable(this);
    }

    public registerRoutes(routes: IRoutes) {
        for(const code in routes) {
            this._routes.set(code, new Route({
                ...routes[code],
                code: code
            }));
        }
    }

    public removeRoutes(routeCodes?: string[]) {
        if(!routeCodes || (Array.isArray(routeCodes) && routeCodes.length === 0)) this._routes.clear();

        if(Array.isArray(routeCodes) && routeCodes.length > 0) {
            routeCodes.forEach(routeCode => this._routes.delete(routeCode));
        }
    }

    private buildRouteTree(routeCode: string): Route | undefined {
        const route = this._routes.get(routeCode);

        if (!route) {
            return undefined;
        }

        if (Array.isArray(route.subRouteCodes)) {
            route.subRoutes = route.subRouteCodes
                .map(code => this.buildRouteTree(code))
                .filter(Boolean) as Route[];
        }

        return route;
    }
    @computed
    get mainMenuRoutesAsArray(): Route[] {
        return Array
            .from(this._routes.values())
            .filter(route => route.hasMainMenuEntry)
            .map(route => this.buildRouteTree(route.code))
            .filter(Boolean);
    }

    @computed
    get routes(): Route[] {
        return Array.from(this._routes.values());
    }

    public getRoute(code: string): Route {
        return this.routes.find(route => route.code === code);
    }
}
